import { useRouter } from "next/router";
import Head from "next/head";
// component
import Inventory from "../../components/Inventory/Inventory";


// lib
import { fetchPageData } from "../../lib/fetchPageData";

function TypePage({ initialData }) {
  const router = useRouter();
  const currentPathName = router.query.type;
  return (
    <>
    <Head>
      <title>{currentPathName}</title>
    </Head>
      <Inventory initialData={initialData}  />
    
    </>

  );
}

export async function getServerSideProps(context) {
  const data = await fetchPageData(context); 
  return {
    props: data,
  };
}


export default TypePage;
